// Zonas dedicadas a usuarios, como mis-datos, mis-suscripciones, procesos de suscripción, etc.
import {intlTelInputBuilder} from "../modulos/intlTelInput/intlTelInput";
import {teLlamamos} from "../modulos/subscriptionUserModules/teLlamamos";
import {tawkChat} from "../modulos/subscriptionUserModules/tawkChat";
import {tableSwiper} from "../modulos/swiper/swiper";
import {
    changeUserDataSubscription,
    paymentMethodChange,
    reconsiderAdvertising
} from "../modulos/subscriptionUserModules/subscription";
import {countrySelectorBuilder} from "../modulos/subscriptionUserModules/countrySelector";

import './css/index-user.scss';

export const loadUsers = async () => {
    console.log('Loading users section');

    tableSwiper()

    return $(function(){
        //Si hay campos _tel, cargar IntlTelInput
        $('input[id$="_tel"]').each(function() {
            intlTelInputBuilder($(this));
        });

        //Si hay un campo _country con un atributo data-country-province-idfield, construimos
        //  el sistema de cambio país -> provincia
        $('select[id$="_idCountry"][data-country-province-idfield]').each(function(){
            countrySelectorBuilder($(this));
        });


        //Te llamamos. Detectar un formulario con nombre "Contact"
        $('form[name="Contact"]').each(function(){
            teLlamamos($(this));
        });

        //Iniciar el chat de Tawk. Si existe un span class="tawkChat"
        const tawkChatSpan = document.querySelector('span.tawkChat');
        if (tawkChatSpan) {
            tawkChatSpan.remove();
            tawkChat();
        }

        //Cambia la información adicional cuando se modifica la forma de pago
        const paymentSelect = $('select[id$="_idPaymentMethod"]');
        if (paymentSelect.length) {
            paymentMethodChange(paymentSelect);
        }

        //Ofrece reconsiderar marcar la casilla de publicidad si no lo ha hecho en registro y suscripción
        const reconsiderAdsInput = $('input[id$="_mailingCommercial"]');
        if (reconsiderAdsInput.length) {
            reconsiderAdvertising(reconsiderAdsInput);
        }

        //En la última pantalla de suscripción se pueden cambiar los datos mediante modal.
        const modalSubscriptionUserData = $('#update-user-data');
        if (modalSubscriptionUserData.length) {
            changeUserDataSubscription();
        }

        //En mis datos, botón de configuración de Quantcast
        /*
        const privacyBtn = document.querySelector('a.privacySettings');
        if (privacyBtn) {
            privacyBtn.addEventListener('click', e => {
                e.preventDefault();
                if (window.__tcfapi) {
                    window.__tcfapi('displayConsentUi', 2, function() {} );
                } else {
                    console.error('Quantcast not found');
                }
            })
        }
        */
    });
}
